import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

// Room for three digits, the most the number field takes
const valueWidth = 64;
// Room for the longest unit (Danish "Måned(er)") beside the dropdown arrow
const unitWidth = 135;
// Matches the library's input corners, so the shared outline looks like any other field
const borderRadius = "10px";

// The three inputs share one outline drawn on the row, so they read as a single "Next 24 months" control.
// Each input's own outline is removed rather than joined, which keeps the radius and hover handling in one place.
export function useRollingPeriodSectionStyles(isFilled: boolean) {
    const theme = useTheme();

    return createSxStyles({
        row: {
            display: "flex",
            borderRadius,
            border: `1px solid ${isFilled ? theme.palette.primary.main : theme.palette.grey.A400}`,
            "&:hover": {
                borderColor: theme.palette.grey.A400,
            },
            // An inset shadow thickens the border on focus without shifting the row by a pixel
            "&:focus-within": {
                borderColor: theme.palette.primary.main,
                boxShadow: `inset 0 0 0 1px ${theme.palette.primary.main}`,
            },
            "& .MuiOutlinedInput-root": {
                borderRadius: 0,
                backgroundColor: "transparent",
            },
            "& .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                border: "none",
            },
            "& .MuiFormHelperText-root": {
                display: "none",
            },
            "& > div:not(:last-of-type)": {
                borderRight: `1px solid ${theme.palette.grey.A400}`,
            },
        },
        direction: {
            flex: 1,
            minWidth: 0,
        },
        value: {
            width: valueWidth,
            flexShrink: 0,
        },
        unit: {
            width: unitWidth,
            flexShrink: 0,
        },
    });
}
